import createListViewContext, { type FilterValues } from 'global/helpers/createListViewContext'

export interface CarriersFilterValues extends FilterValues {
  keywords: string[]
  integrations: string[]
  telematics: string[]
  features: string[]
}

const defaultFilters: CarriersFilterValues = {
  keywords: [],
  integrations: [],
  telematics: [],
  features: [],
}

const { ListViewProvider, useListView } = createListViewContext(defaultFilters)

export { ListViewProvider as CarriersViewProvider, useListView as useCarriersView }
